import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=64d81fd6"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d81fd6')) {
      api.createRecord('64d81fd6', component.options)
    } else {
      api.reload('64d81fd6', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=64d81fd6", function () {
      api.rerender('64d81fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/layout/Index.vue"
export default component.exports